import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FrustrationMethodSection() {
  const benefits = ['Volver a comer pan, pizza y dulces sin gluten… sin inflamación y sin fallar en el intento', '✔ Resultados esponjosos, con sabor real y sin picos de azúcar', 'Resultados desde el primer intento sin desperdiciar ingredientes ni dinero', 'Ingredientes accesibles que puedes conseguir fácilmente'];
  return <section className="py-12 md:py-16 px-4 bg-[#FFFBEB] pt-[0px] pb-[0px] pl-[13px] pr-[13px]" data-id="element-146">
      <div className="max-w-2xl mx-auto" data-id="element-147">
        {/* Headline */}
        <h2 className="md:text-3xl font-black text-center mb-3 text-gray-900 font-[Merriweather,_serif] tracking-tight text-[24px] pt-[15px] pb-[15px]" data-id="element-148">
          ¿Cocinar sin gluten te ha resultado frustrante?
        </h2>

        {/* Subheadline - High contrast as requested */}

        {/* Content Box */}
        <div className="border border-[#F0EBE0] rounded-2xl p-6 md:p-8 mb-10 shadow-sm bg-[#FFFFFF]" data-id="element-149">
          <p className="text-gray-800 mb-4 text-[16px] md:text-lg leading-relaxed" data-id="element-150">
            Recetas que no funcionan. Ingredientes caros. Resultados incomibles.
          </p>

          <p className="text-gray-700 mb-4 text-[15px] md:text-base leading-relaxed" data-id="element-151">
            Si eres diabético o celíaco, seguramente ya lo viviste:
          </p>

          <ul className="space-y-2.5 mb-6 pl-1" data-id="element-152">
            <li className="flex items-start gap-2.5 text-gray-700 text-[15px] md:text-base leading-snug" data-id="element-153">
              <span className="text-red-400 flex-shrink-0 mt-0.5" data-id="element-154">✕</span>
              Dejaste de comer lo que te gusta
            </li>
            <li className="flex items-start gap-2.5 text-gray-700 text-[15px] md:text-base leading-snug" data-id="element-155">
              <span className="text-red-400 flex-shrink-0 mt-0.5" data-id="element-156">✕</span>
              Gastaste dinero en vano
            </li>
            <li className="flex items-start gap-2.5 text-gray-700 text-[15px] md:text-base leading-snug" data-id="element-157">
              <span className="text-red-400 flex-shrink-0 mt-0.5" data-id="element-158">✕</span>
              Nada te sale bien en casa
            </li>
          </ul>

          <p className="text-gray-500 italic mb-5 text-[14px] md:text-[15px]" data-id="element-159">
            Y terminas pensando: "esto no es para mí"…
          </p>

          <p className="text-gray-900 font-bold text-[17px] md:text-xl leading-snug" data-id="element-160">
            Solo necesitas un sistema claro que funcione desde el primer
            intento.
          </p>
        </div>

        {/* Transition Text */}
        <p className="text-center font-bold text-gray-900 md:text-xl mb-8 text-[20px]" data-id="element-161">
          Por eso creamos un método paso a paso con el que podrás 👇
        </p>

        {/* Benefit Cards */}
        <div className="space-y-3 md:space-y-4" data-id="element-162">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#F0FDF4] border border-[#4ADE80]/40 rounded-xl p-4 md:p-5 flex items-start gap-3 md:gap-4 shadow-sm" data-id="element-163">
              <div className="bg-white rounded-full p-0.5 shadow-sm border border-green-100 flex-shrink-0 mt-0.5" data-id="element-164">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#22C55E]" data-id="element-165" />
              </div>
              <p className="text-gray-800 font-medium leading-tight md:text-lg" data-id="element-166">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}